import { Button } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { HomeOutlined } from "@ant-design/icons";

const defaultCountDown = 5;

export const NotFoundPage = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const [countDown, setCountDown] = useState(defaultCountDown);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCountDown((c) => c - 1);
    }, 1000);

    const timeoutId = setTimeout(() => {
      navigate("/", { replace: true });
    }, defaultCountDown * 1000);

    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, [navigate]);

  return (
    <div className="w:100vw h:100vh  flex jc:center ai:center bg:#dedede">
      <div className="pb:10% flex flex:col ai:center gap:10">
        <h1 className="mb:20">404</h1>
        <p>{t("pages.NotFound.sorryPageNotExists")}</p>
        <p>{t("pages.NotFound.theLinkInvalidOrPageRemoved")}</p>

        <Button
          danger
          size="large"
          type="primary"
          className="w:120 mt:20"
          icon={<HomeOutlined />}
        >
          <Link to="/">{t("pages.NotFound.backToHome")}</Link>
        </Button>

        <small>{t("pages.NotFound.redirectAfterSeconds", { countDown })}</small>
      </div>
    </div>
  );
};
